import { gql } from '@apollo/client';
import { INBOX_ITEM_FIELDS } from '../queries/inbox';

export const SUPPLIER_INBOX_UPDATED = gql`
  subscription SupplierInboxUpdated {
    supplierInboxUpdated {
      action
      item {
        ...InboxItemFields
      }
    }
  }
  ${INBOX_ITEM_FIELDS}
`;
